module.exports = __webpack_public_path__ + "8cee263a77e88622775080e6b9dea69e.svg";